<template>
  <div class="flex flex-col lg:flex-row c-spacing">

    <label
      v-for="option in options" 
      :key="option.value"
      :class="{ 'bg-blue-1000 s-checked': isChecked(option.value) }"
      :style="getStyle(option)"
      class="cursor-pointer rounded-lg p-4 s-slider-option hover:bg-black"
    >
      <input
        @input.passive="local_navigate"
        type="radio" 
        :value="option"
      />
      <span class="s-font font-bold text-white">
        {{ option }}
      </span>
    </label>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Slider',
  computed: {
    ...mapState([
      'step',
    ]),
    data: {
      get () {
        // return this.$store.state.results[this.$store.state.step].response;
        return this.$store.state.exam_responses?.[this.question.prompt];
      },
      set(response) {
        this.$store.commit('SET_PROMPT_AND_QUESTION', { prompt: this.question.prompt, response });
        // this.$store.commit('SET_QUESTION', this.question);
        // this.$store.commit('SET_RESPONSE', response);
      }
    },
  },
  props: {
    question: {
      required: true,
      type: Object
    },
    options: {
      required: true,
      type: Array,
    }
  },
  methods: {
    ...mapActions([
      'navigate',
    ]),
    local_navigate(e) {
      this.data = e.target.defaultValue; // instead of v-model
      this.navigate(true); // automatically move
    },  
    isChecked(value) { // radio's data will always be a string, so compare it
      if (this.data && this.data == value) {
        return true;
      } else return false;
    },
    getStyle(number) {
      let style = '';
      switch(number) {
        case(1):
          style = style.concat(' background-color: #0f0;');
          break;
        case(2):
          style = style.concat(' background-color: #3f0;');
          break;
        case(3):
          style = style.concat(' background-color: #6f0;');
          break;
        case(4):
          style = style.concat(' background-color: #9f0;');
          break;
        case(5):
          style = style.concat(' background-color: #cf0;');
          break;
        case(6):
          style = style.concat(' background-color: #fc0;');
          break;
        case(7):
          style = style.concat(' background-color: #f90;');
          break;
        case(8):
          style = style.concat(' background-color: #f60;');
          break;
        case(9):
          style = style.concat(' background-color: #f30;');
          break;
        case(10):
          style = style.concat(' background-color: red;');
          break;
      }
      return style;
    }
  },
}
</script>

<style lang="scss" scoped>

.s-font {
  font-size: 3rem;
}

.s-slider-option {
  display: grid;
  place-content: center;
  height: 3.75rem; 
  width: 3.75rem;
  :hover {
    height: 3.75rem; 
    width: 3.75rem;
    background-color: rgba(black, 0.4);
    border-radius: 0.5rem;
    display: grid;
    place-content: center;
  }
}

.c-spacing {
  label {
    margin-right: 0.35em!important;
  }
  
}
input {
  display: none!important;
}

</style>